import { quadrantsENUM } from './config/quadrants';
import { ringsENUM } from './config/rings';

const lastUpdate = new Date('2022-11-28');

export default [
  {
    timeline: [
      {
        moved: 0,
        ringId: ringsENUM.ADOPT,
        date: lastUpdate,
        description: '',
      },
    ],
    url: '#',
    key: 'distributed-applications',
    id: 'distributed-applications',
    title: 'Distributed Applications',
    quadrant: quadrantsENUM.TECHNIQUES,
    description: '',
  },
  {
    timeline: [
      {
        moved: 0,
        ringId: ringsENUM.ADOPT,
        date: lastUpdate,
        description: '',
      },
    ],
    url: '#',
    key: 'Continuos-deploy',
    id: 'Continuos-deploy',
    title: 'Continuos deploy (CD)',
    quadrant: quadrantsENUM.TECHNIQUES,
    description: '',
  },
  {
    timeline: [
      {
        moved: 0,
        ringId: ringsENUM.ADOPT,
        date: lastUpdate,
        description: '',
      },
    ],
    url: '#',
    key: 'Cloud-Native-Apps',
    id: 'Cloud-Native-Apps',
    title: 'Cloud Native Apps',
    quadrant: quadrantsENUM.TECHNIQUES,
    description: '',
  },
  {
    timeline: [
      {
        moved: 0,
        ringId: ringsENUM.ADOPT,
        date: lastUpdate,
        description: '',
      },
    ],
    url: '#',
    key: 'Containers',
    id: 'Containers',
    title: 'Containers',
    quadrant: quadrantsENUM.TECHNIQUES,
    description: '',
  },
  {
    timeline: [
      {
        moved: 0,
        ringId: ringsENUM.ADOPT,
        date: lastUpdate,
        description: '',
      },
    ],
    url: '#',
    key: 'Cost-Management',
    id: 'Cost-Management',
    title: 'Cost Management',
    quadrant: quadrantsENUM.TECHNIQUES,
    description: '',
  },
  {
    timeline: [
      {
        moved: 0,
        ringId: ringsENUM.ADOPT,
        date: lastUpdate,
        description: '',
      },
    ],
    url: '#',
    key: 'Design-Docs',
    id: 'Design-Docs',
    title: 'Design Docs',
    quadrant: quadrantsENUM.TECHNIQUES,
    description: '',
  },
  {
    timeline: [
      {
        moved: 0,
        ringId: ringsENUM.ADOPT,
        date: lastUpdate,
        description: '',
      },
    ],
    url: '#',
    key: 'Event-driven-architecture',
    id: 'Event-driven-architecture',
    title: 'Event driven architecture',
    quadrant: quadrantsENUM.TECHNIQUES,
    description: '',
  },
  {
    timeline: [
      {
        moved: 0,
        ringId: ringsENUM.ADOPT,
        date: lastUpdate,
        description: '',
      },
    ],
    url: '#',
    key: 'REST-APIs',
    id: 'REST-APIs',
    title: 'REST APIs',
    quadrant: quadrantsENUM.TECHNIQUES,
    description: '',
  },
  {
    timeline: [
      {
        moved: 0,
        ringId: ringsENUM.ADOPT,
        date: lastUpdate,
        description: '',
      },
    ],
    url: '#',
    key: 'Feature-Flag',
    id: 'Feature-Flag',
    title: 'Feature Flag',
    quadrant: quadrantsENUM.TECHNIQUES,
    description: '',
  },
  {
    timeline: [
      {
        moved: 0,
        ringId: ringsENUM.ADOPT,
        date: lastUpdate,
        description: '',
      },
    ],
    url: '#',
    key: 'Canary-Deploy',
    id: 'Canary-Deploy',
    title: 'Canary Deploy',
    quadrant: quadrantsENUM.TECHNIQUES,
    description: '',
  },
  {
    timeline: [
      {
        moved: 0,
        ringId: ringsENUM.ADOPT,
        date: lastUpdate,
        description: '',
      },
    ],
    url: '#',
    key: 'Shadow-Testing',
    id: 'Shadow-Testing',
    title: 'Shadow-Testing',
    quadrant: quadrantsENUM.TECHNIQUES,
    description: '',
  },
];